import { Map, fromJS, is } from 'immutable';
import { resetMaster as registerResetMaster } from '../actions/pureActions/registerActions';

// Action
const UPDATE_FORM_STATE = 'rff/UPDATE';
const CLEAR_FORM_STATE = 'rff/CLEAR';
const REGISTER_RESET_MASTER = registerResetMaster.toString();

export default function reducer(state = Map(), action = {}) {
  switch (action.type) {
    case UPDATE_FORM_STATE: {
      const next = fromJS(action.payload);
      const prev = state.get(action.form);
      return is(prev, next) ? state : state.set(action.form, next);
    }
    case CLEAR_FORM_STATE:
      return state.delete(action.form);
    case REGISTER_RESET_MASTER:
      return state.filter((_, key) => !key.startsWith('FORM_REGISTER_'));
    default:
      return state;
  }
}

// Action creators
export const updateFormState = (form, formState) => ({
  type: UPDATE_FORM_STATE,
  form,
  payload: formState,
});

export const clearFormState = (form) => ({
  type: CLEAR_FORM_STATE,
  form,
});

// Selectors
export const getRffForm = (state, formName) =>
  state.getIn(['rff', formName]) || Map();

export const getRffFormValues = (state, formName) =>
  state.getIn(['rff', formName, 'values']) || Map();

/**
 * redux-form legacy compatible formValueSelector:
 * - formValueSelector(formName)(state) -> Immutable Map of all values
 * - formValueSelector(formName)(state, 'a') -> value of 'a'
 * - formValueSelector(formName)(state, 'a', 'b') -> Immutable Map({ a, b })
 * Supports shallow field names (add getIn/splitting if you use dotted paths).
 */
export const formValueSelector =
  (formName) =>
  (state, ...names) => {
    const values = state.getIn(['rff', formName, 'values']) || Map();

    if (names.length === 0) {
      return values; // full values map
    }
    if (names.length === 1) {
      return values.get(names[0]);
    }
    // multiple fields -> map of selected fields
    return Map(names.map((n) => [n, values.get(n)]));
  };
